// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfSecond as fn } from "../startOfSecond.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfSecond = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfSecond;
